import apiClient from "./apiClient";

export const listPortfolioCategories = async ({ search = "", page = 1 } = {}) => {
  const { data } = await apiClient.get("/portfolio-categories", {
    params: { search: search || undefined, page },
  });
  return { categories: data.data, pagination: data.meta.pagination };
};

export const createPortfolioCategory = async (payload) => {
  const { data } = await apiClient.post("/portfolio-categories", payload);
  return data.data;
};

export const updatePortfolioCategory = async (id, payload) => {
  const { data } = await apiClient.put(`/portfolio-categories/${id}`, payload);
  return data.data;
};

export const deletePortfolioCategory = async (id) => {
  await apiClient.delete(`/portfolio-categories/${id}`);
};
